/**
 * API pour sofaxis-fonpel-espace-elus
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OnboardingNotification { 
    type?: OnboardingNotification.TypeEnum;
    resourceId?: string;
}
export namespace OnboardingNotification {
    export type TypeEnum = 'UNKNOWN' | 'SUCCESS' | 'ERROR';
    export const TypeEnum = {
        Unknown: 'UNKNOWN' as TypeEnum,
        Success: 'SUCCESS' as TypeEnum,
        Error: 'ERROR' as TypeEnum
    };
}


